module.exports = __webpack_public_path__ + "img/product8.78c60f11.png";